var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.935 0h.092c.43.206.86.424 1.265.681 4.725 2.675 9.45 5.349 14.173 8.036a1 1 0 01.536 1.016c-.014 5.644 0 11.288 0 16.92-.066.27-.235.501-.47.656-5.025 2.854-10.05 5.695-15.074 8.537a.778.778 0 01-.861.051C10.57 33.043 5.547 30.201.523 27.347A.893.893 0 010 26.486V9.566a.906.906 0 01.51-.862C5.22 6.043 9.944 3.37 14.655.694c.418-.244.835-.488 1.28-.694z",
    fill: "#019639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.564 10.98v13.963a1.904 1.904 0 00.562 1.401c.717.707 1.84.81 2.688.27a2.07 2.07 0 00.887-1.671c0-3.369-.013-6.737 0-10.106 3.12 3.677 6.238 7.354 9.37 11.019a3.72 3.72 0 003.394 1.002 2.019 2.019 0 001.631-1.761c.013-4.744.013-9.501 0-14.246A2.044 2.044 0 0022.864 9a2.061 2.061 0 00-1.879 1.851c0 3.42-.026 6.84 0 10.26-3.067-3.561-6.081-7.148-9.135-10.71a3.703 3.703 0 00-3.459-1.35 2.019 2.019 0 00-1.827 1.929z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_175"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/Nginx.3b4831bb4d98baec456b5d5be78f13aa.svg";
export { ForwardRef as ReactComponent };